<template>
    <section id="hero" class="d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 pt-5 pt-lg-0 order-1 order-lg-1">
            <img src="./../assets/img/signr.png" class="img-fluid signr-animated" alt="">
            <img src="./../assets/img/signr-becomes-verified.png" class="img-fluid fixed" alt="">
            <img src="./../assets/img/verified.png" class="img-fluid verified-animated" alt="">
            <img src="./../assets/img/signr-verified-transparent.png" class="img-fluid fixed-mobile" alt="">
          </div>
          <div class="col-lg-6 order-2 order-lg-2 hero-img">
            <h2 class="mt-3">{{__('verified-features')}}</h2>
            <a :href="getURL()" class="btn-go">{{__('go-to-verified')}}</a>
          </div>
        </div>
      </div>
    </section>
</template>
<script>
export default {
    props: ['lang'],
    methods:{
      getURL(){
        let lang = this.lang.substr(0,2)
        lang = (lang === 'sv') ? 'se' : lang
        return `https://www.verified.eu/${lang}`
      }
    }
}
</script>